import React, { useState, useEffect } from "react";
import ReactIdSwiper from "react-id-swiper";
import * as action from '../Actions';

export default (props) => {
  // //console.log(props);
  var data = props.data;
  // Swiper instance
  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  var elePagi = ".swiper-pagination";
  if (props.page == "home-banners") {
    elePagi = ".swiper-pagination.swiper-pagination-white";
  }
  var params = {};
  // Params definition
 (props.page == "dr-carousel-unit")
    params = {
      loop: true,
        slidesPerView: "auto",
        slidesPerView: 3.5,
        spaceBetween: 12,
         breakpoints: {
        767: {
          slidesPerView: 3.3,
          spaceBetween: 8
        },
      },
      getSwiper: updateSwiper // Get swiper instance callback
    }
  

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => updateCurrentIndex(swiper.realIndex));
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  return (
    <div>
      <ReactIdSwiper {...params}>
        {data.map((item, idx) => (
          (props.page == "dr-carousel-unit" ?
            <div className="swiper-slide_feed " key={idx}>
                <div className="baby_week_main_content">
                      <a href={action.getCategoryUrl(item.categoryName)}>
                        <div className="baby_opacity_main">
                          <img src={item.categoryImage} alt="logo"/>
                        </div>
                        <div className="baby_week_name_content">
                            <div className="baby_name_text M14_white"> {item.categoryName} </div>
                        </div>
                      </a>
                </div>
            </div>
            :
            <div className="swiper-slide_feed" key={idx}>
              <img src="https://bbcdnlivemumbai.s3.ap-south-1.amazonaws.com/brainbees/community/memoryimages/1584339297p4706331.jpeg" />
            </div>
          )
        ))}
      </ReactIdSwiper>
      <div className="buttons buttons-list" style={{ display: "none" }}>
        <button id="prevSlide" className="button is-primary" onClick={goPrev}>
          Prev
        </button>
        <button id="nextSlide" className="button is-primary" onClick={goNext}>
          Next
        </button>
      </div>
    </div>
  );
};
